export enum TypePillSize {
  default = 'default',
  small = 'small',
  tiny = 'tiny'
}
